import Swiper, { Pagination, Autoplay } from 'swiper';
import InitAutoplay from '../../../scripts/initAutoplay.js';
Swiper.use([Pagination, Autoplay]);

let sponsorSlider = null;

const sponsorMobileConfig = {
  navigation: {
    nextEl: '.er_sponsor__inner__mobile__arrows__next',
    prevEl: '.er_sponsor__inner__mobile__arrows__prev',
  },
  pagination: {
    el: '.er_sponsor__inner__mobile__pagination',
    clickable: true,
    spaceBetween: 30,
    resizeObserver: true,
    grabCursor: true,
  },
};

const initSlider = () => {
  if (window.matchMedia('(max-width: 1024px)').matches && !!!sponsorSlider) {
    sponsorSlider = new Swiper('.er_sponsor__inner__mobile_container', sponsorMobileConfig);
  }

  if (sponsorSlider && window.matchMedia('(max-width: 1024px)').matches) {
    window.addEventListener('scroll', () => {
      InitAutoplay(sponsorSlider, 'er_sponsor', 6000);
    });
  }
};

export default () => {
  initSlider();
  window.addEventListener('resize', initSlider, false);
};
